import GlobalStyles from "../../assets/styles/GlobalStyles";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import MetaTags from "./MetaTags";

const Layout = ({ children }) => {
  return (
    <>
      <MetaTags />
      <GlobalStyles />
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
